import React, { useState, useEffect, Suspense } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import Bell from "./assets/BellIcon.mp3";
import AlertBell from "./assets/alertbell.wav";
import {
  Bell as BellIcon,
  Inbox as InboxIcon,
  Search,
  UserCircle,
} from "lucide-react";
import {
  FaInbox,
  FaBell,
  FaRocketchat,
  FaBullhorn,
  FaUserCircle,
} from "react-icons/fa";
import {
  getUser,
  isCurrentUserTeamLead,
  socket_url,
} from "./utilis/Common";
import PermissionRoute from "./utilis/PermissionRoute";
import FinanceRoute from "./utilis/FinanceRoute";
import {
  canAccessFinanceInvoicesHub,
  canAccessFinanceModule,
  canViewApplicationCommissionReport,
  canViewApplicationInvoices,
  canViewCommissionInstallmentsQueue,
  canViewCommissionModule,
  canViewProfessionalCost,
  canAccessCommissionInvoiceEditor,
} from "./utilis/invoicePermissionHelpers";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import {
  get_ApiManager,
  post_ApiManager,
} from "./components/ApiManager/ApiManager";
import Dashboard from "./components/Dashboard/dashboard";
import Login from "./components/Login/login";
import PrivateRoute from "./utilis/PrivateRoute";
import Sidebar from "./components/Sidebar/Sidebar";
import NotificationBar from "./components/Notification/notification";
import NavItem from "./components/Header/NavItem";
import "./components/Header/header.css";
import ViewAccounts from "./components/Accounts/ViewAccounts";
import AddAgent from "./components/Agents/AddAgent";
import ViewAgents from "./components/Agents/ViewAgents";
import ViewAppointments from "./components/Appointments/ViewAppointments";
import ViewClients from "./components/Clients/ViewClients";
import AddClient from "./components/Clients/AddClient";
import MyClients from "./components/Clients/MyClients";
import ViewLeads from "./components/Clients/ViewLeads";
import Reports from "./components/Clients/Reports";
import Counseling from "./components/Counseling/counseling";
import ManageBranch from "./components/Branches/manageBranch";
import MainApplications from "./components/Applications/MainApplications";
import ProviderSettings from "./components/Providers/ProviderSettings";
import AddProvider from "./components/Providers/addProviders";
import ViewProviders from "./components/Providers/viewProviders";
import ViewCost from "./components/Finance/ViewCost";
import PreviewInvoice from "./components/GeneratePDF/PreviewInvoice";
import AssignClients from "./components/Clients/AssignClients";
import ExpoAugSep from "./components/Expo2022/ExpoAugSep";
import MainEvent from "./components/Expo2022/MainEvent";
import Attendence from "./components/HRManagement/Attendence";
import ApplyLeave from "./components/Leave/ApplyLeave";
import ManageLeaves from "./components/HRManagement/ManageLeaves";
import moment from "moment";
import ViewCommissions from "./components/Finance/viewCommissions";
import AlertDetail from "./components/Notification/AlertDetail";
import Inbox from "./components/Inbox/inbox";
import HeaderQuickOpen from "./components/Header/HeaderQuickOpen";
import HandleInbox from "./components/Inbox/handleInbox";
import ViewPriority from "./components/Applications/Priority";
import UserRoles from "./components/HRManagement/UserRoles";
import DailyTask from "./components/DailyReport/dailyReport";
import AllDailyReport from "./components/HRManagement/AllDailyReport";
import UserReportHistory from "./components/HRManagement/UserReportHistory";
import ViewReport from "./components/HRManagement/ViewReport";
import ExternalApps from "./components/Applications/ExternalApps";
import ExternalClients from "./components/Clients/ExternalClients";
import ViewInternalNotes from "./components/MeetingNotes/viewInternalNotes";
import InternalNoteDetail from "./components/MeetingNotes/InternalNoteDetail";
import AttendenceForEmployee from "./components/Dashboard/attendanceForEmployee";
import { apiUrl } from "./components/ApiManager/AxiosHeaders";
import {
  getChatNotifications,
  getMarkAsSeen,
  getUnSeen,
  getUnSeenAlert,
} from "./components/Services/apiServices";
import Loader from "./components/Loader/Loader";
import TestForm from "./components/Expo2022/TestForm";
import ProcessingReports from "./components/ProcessingReports/processingReports";
import ViewProcessingReport from "./components/ProcessingReports/ViewProcessingReports";
import ProcessingTasksCards from "./components/ProcessingTasks/processingTasksCards";
import WebsiteLeads from "./components/WebsiteLeads/website-leads";
import MyWebsiteLeads from "./components/WebsiteLeads/my-website-leads";
import Leads from "./components/Leads/Leads";
import AddLeads from "./components/Leads/AddLeads";
import MyLeads from "./components/Leads/MyLeads";
import ApplicationFeeRule from "./components/Accounts/ApplicationFeeRule";
import DiscountRule from "./components/Accounts/DiscountRule";
import ProfessionalCost from "./components/Finance/ProfessionalCost";
import Compaign from "./components/Leads/Compaign";
import Branches from "./components/Branches/Branches";
import Policies from "./components/HRManagement/Policies";
import AttendencePolicies from "./components/HRManagement/AttendencePolicies";
import EmployeeMonthlyAttendance from "./components/HRManagement/EmployeeMonthlyAttendance";
import LeavePolicies from "./components/HRManagement/LeavePolicies";
import UserLeave from "./components/Leave/UserLeave";
import LeaveRequestStatus from "./components/Leave/LeaveRequestStatus";
import HRManageLeaves from "./components/HRManagement/HRManageLeaves";
import ManageDepartments from "./components/HRManagement/ManageDepartments";
import ManageTeams from "./components/HRManagement/ManageTeams";
import ManageNotification from "./components/HRManagement/ManageNotification";
import Commissions from "./components/reports/Commissions";
import CommissionDetailRoute from "./components/reports/commissions/CommissionDetailRoute";
import CommissionCreateInvoice from "./components/reports/commissions/CommissionCreateInvoice";
import CommissionEditInvoice from "./components/reports/commissions/CommissionEditInvoice";
import InquiryBatchesPage from "./components/reports/commissions/InquiryBatchesPage";
import InquiryBatchDetailPage from "./components/reports/commissions/InquiryBatchDetailPage";
import CommissionRulesPage from "./components/reports/commissions/CommissionRulesPage";
import CommissionInstallmentsQueuePage from "./components/reports/commissions/CommissionInstallmentsQueuePage";
import AgentBonus from "./components/Providers/AgentBonus";
import CheckList from "./components/Checklist/CheckList";
import AddCheckList from "./components/Checklist/AddCheckList";
import CheckListCategories from "./components/Checklist/CheckListCategories";
import ChecklistToProviders from "./components/Checklist/ChecklistToProviders";
import AttachCheckListToProviders from "./components/Checklist/AttachCheckListToProviders";
import LeadsReporting from "./components/Leads/LeadsReporting";
import TotalPriority from "./components/Applications/TotalPriority";
import MyPriority from "./components/Applications/MyPriority";
import MedicalInsurance from "./components/Finance/MedicalInsurance";
import GstSetting from "./components/Finance/GstSetting";
import InvoiceBranding from "./components/Finance/InvoiceBranding";
import Invoices from "./components/Finance/Invoices";
import FinanceCreateInvoice from "./components/Finance/FinanceCreateInvoice";
import FinanceEditInvoice from "./components/Finance/FinanceEditInvoice";
import ExpiringProviders from "./components/Providers/ExpiringProviders";
import ProviderInsights from "./components/Providers/ProviderInsights";
import WalkInClients from "./components/Clients/WalkInClients";
import ClientSignupData from "./components/reports/ClientSignupData";
import AttendanceReport from "./components/HRManagement/AttendanceReport";
import SOP_Policies from "./components/SOP&Policies/SOP_Policies";
import SOP_Policies_Categories from "./components/SOP&Policies/SOP_Policies_Categories";
import ManageSOP from "./components/SOP&Policies/ManageSOP";
import CompanyFormsLibrary from "./components/CompanyForms/CompanyFormsLibrary";
import CompanyFormsManage from "./components/CompanyForms/CompanyFormsManage";
import CompanyFormsApprove from "./components/CompanyForms/CompanyFormsApprove";
import CompanyFormsCategories from "./components/CompanyForms/CompanyFormsCategories";
import InvoiceReports from "./components/reports/InvoicesReports/InvoicesReports";
import DailyActivityLogger from "./components/TaskManagement/DailyActivityLogger/DailyActivityLogger";
import DailyReportingDashboard from "./components/reports/DailyTaskReports/DailyReportingDashboard";
import DailyReportingEmployee from "./components/reports/DailyTaskReports/DailyReportingEmployee";

function LegacyTaskWorkspaceRedirect() {
  return (
    <Navigate
      to={isCurrentUserTeamLead() ? "/daily-reporting" : "/my-tasks"}
      replace
    />
  );
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const JobDescriptions = React.lazy(
    () => import("./components/SOP&Policies/JobDescriptions"),
  );
  const EmployeeContracts = React.lazy(
    () => import("./components/SOP&Policies/EmployeeContracts"),
  );
  const EditAgent = React.lazy(() => import("./components/Agents/EditAgent"));
  const Permissions = React.lazy(
    () => import("./components/Permission/permissions"),
  );
  const Profile = React.lazy(() => import("./components/Profile/Profile"));
  const ViewAllStatus = React.lazy(
    () => import("./components/Dashboard/viewAllStatus"),
  );
  const CountryClients = React.lazy(
    () => import("./components/Clients/countryClients"),
  );
  const ShowAllNotification = React.lazy(
    () => import("./components/Notification/ShowAllNotification"),
  );
  const ViewActivityDetail = React.lazy(
    () => import("./components/Settings/ViewActivityDetail"),
  );
  const AllMigrationApps = React.lazy(
    () => import("./components/Applications/AllMigrationApps"),
  );
  const AllEducationApps = React.lazy(
    () => import("./components/Applications/AllEducationApps"),
  );
  const AssignEducationApp = React.lazy(
    () => import("./components/Applications/AssignApplication/AssignEducation"),
  );
  const AssignMigrationsApp = React.lazy(
    () => import("./components/Applications/AssignApplication/AssignMigration"),
  );
  const MyMigrationsApp = React.lazy(
    () =>
      import("./components/Applications/MyApplications/MigrationApplications"),
  );
  const MyEducationApp = React.lazy(
    () =>
      import("./components/Applications/MyApplications/EducationApplications"),
  );
  const ViewMigrationAppDetail = React.lazy(
    () => import("./components/Applications/ViewMigrationDetail"),
  );
  const ViewEducationAppDetail = React.lazy(
    () => import("./components/Applications/ViewEducationDetail"),
  );
  const ViewPreChecklistDetails = React.lazy(
    () => import("./components/Checklist/viewPreChecklistDetails"),
  );
  const AddChecklistCategory = React.lazy(
    () => import("./components/Checklist/addChecklistCategory"),
  );
  const CreateMigApp = React.lazy(
    () => import("./components/Applications/CreateMigApp"),
  );
  const CreateEduApp = React.lazy(
    () => import("./components/Applications/CreateEduApp"),
  );
  const ViewClientDetail = React.lazy(
    () => import("./components/Clients/ViewClientDetail"),
  );
  const ViewClientProfile = React.lazy(
    () => import("./components/Clients/ClientProfile"),
  );
  const ClientInvoices = React.lazy(
    () => import("./components/Clients/ClientInvoices"),
  );
  const ClientCreateInvoice = React.lazy(
    () => import("./components/Clients/ClientCreateInvoice"),
  );
  const ClientEditInvoice = React.lazy(
    () => import("./components/Clients/ClientEditInvoice"),
  );
  const UserClients = React.lazy(
    () => import("./components/Clients/viewUserClients"),
  );
  const EditCourse = React.lazy(
    () => import("./components/Providers/editCourse"),
  );
  const ViewClientReport = React.lazy(
    () => import("./components/Settings/viewClientReport"),
  );
  const SendCheckList = React.lazy(
    () => import("./components/Checklist/sendChecklist"),
  );
  const ProviderDetail = React.lazy(
    () => import("./components/Providers/providerDetail"),
  );
  const EditProvider = React.lazy(
    () => import("./components/Providers/editProvider"),
  );
  const AddCourse = React.lazy(
    () => import("./components/Providers/addCourse"),
  );
  const ViewChecklists = React.lazy(
    () => import("./components/Checklist/viewChecklists"),
  );
  const AddPreCheckList = React.lazy(
    () => import("./components/Checklist/addPreChecklist"),
  );
  const MainSetttings = React.lazy(
    () => import("./components/Settings/Main"),
  );
  const MainChecklist = React.lazy(
    () => import("./components/Checklist/mainChecklist"),
  );
  const ViewPreChecklists = React.lazy(
    () => import("./components/Checklist/viewPreChecklist"),
  );
  const ViewStatusDetail = React.lazy(
    () => import("./components/Dashboard/viewStatusDetail"),
  );
  const Logout = React.lazy(() => import("./components/Header/Logout"));
  const EditInvoice = React.lazy(
    () => import("./components/Finance/Invoice/EditInvoice"),
  );
  const ViewAllFollowups = React.lazy(
    () => import("./components/Dashboard/viewAllFollowups"),
  );
  const StatusFollowup = React.lazy(
    () => import("./components/Dashboard/StatusFollowup"),
  );
  const ExpoDetail = React.lazy(
    () => import("./components/Expo2022/ExpoDetail"),
  );
  const ConsultantList = React.lazy(
    () => import("./components/Expo2022/ConsultantList"),
  );
  const AttendenceDetail = React.lazy(
    () => import("./components/HRManagement/AttendenceDetail"),
  );
  const EditAttendence = React.lazy(
    () => import("./components/HRManagement/EditAttendence"),
  );
  const CreateEvent = React.lazy(
    () => import("./components/Expo2022/CreateEvent"),
  );
  const ExpoFollowup = React.lazy(
    () => import("./components/Expo2022/ExpoFollowup"),
  );
  const AddAlerts = React.lazy(
    () => import("./components/HRManagement/AddAlerts"),
  );
  const CreateAlerts = React.lazy(
    () => import("./components/HRManagement/CreateAlerts"),
  );
  const HandleChat = React.lazy(
    () => import("./components/Login/Chat/HandleChat"),
  );

  // End Routes

  const [profileImage, setProfileImage] = useState(null);
  const location = useLocation();
  const history = useNavigate();
  const user = useState(JSON.parse(localStorage.getItem("user_id")));
  const [loggedInUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [ip, setIP] = useState([null]);
  const [socket, setSocket] = useState(null);
  const { Howl } = require("howler");
  const [notifications, setNotifications] = useState([]);
  const [seenStatus, setSeenStatus] = useState(null);
  const [notificationCount, setNotificationCount] = useState(0);
  const [seenAlert, setSeenAlert] = useState(null);
  const [activeUsers, setActiveUsers] = useState([]);
  const [attendance, setAttendance] = useState(true);
  const [chatNotiication, setChatNotification] = useState(0);

  useEffect(() => {
    checkToken();
    // Reset the auto-open flag when a new token is detected (new login session)
    const token = localStorage.getItem("token");
    const SESSION_SEEN_KEY = "sessionTokenSeen";
    const POPUP_FLAG = "notificationPopupShown";
    const prevSeen = localStorage.getItem(SESSION_SEEN_KEY);
    if (token && prevSeen !== token) {
      localStorage.setItem(SESSION_SEEN_KEY, token);
      localStorage.removeItem(POPUP_FLAG);
    }
    // Initialize unread notifications count on app load (if logged in)
    if (
      localStorage.getItem("token") &&
      window.location.pathname !== "/login"
    ) {
      allNotification();
    }
    // Check the token status every 10 minutes
    const tokenCheckInterval = setInterval(checkToken, 10 * 60 * 1000);
    // Clean up the interval when the component unmounts
    return () => clearInterval(tokenCheckInterval);
    // setSocket(io("127.0.0.1:3002"));
  }, []);

  useEffect(() => {
    const newSocket = io(socket_url());

    newSocket.on("connect_error", (err) => {
      console.error("Socket connection failed:", err);
    });
    console.log("Socket connected:", newSocket);
    setSocket(newSocket);
    // Cleanup on unmount
    return () => {
      newSocket.off("connect_error");
      newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket) {
      window.__cmsStaffSocket = socket;
    }
  }, [socket]);

  // Join user_${id} on every connect/reconnect so io.to(`user_${receiverId}`) delivers getChatNotification
  useEffect(() => {
    if (!socket) return;

    const joinChatUserRoom = () => {
      if (!localStorage.getItem("token")) return;
      const u = getUser();
      if (u?.id == null) return;
      socket.emit("newUser", u.id, u["profile_image_url"]);
    };

    socket.on("connect", joinChatUserRoom);
    if (socket.connected) {
      joinChatUserRoom();
    }

    return () => {
      socket.off("connect", joinChatUserRoom);
    };
  }, [socket]);

  useEffect(() => {
    if (seenStatus === null && window.location.pathname != "/login") {
      getSeenStatus(1);
      getSeenAlert(0, 1);
    }
    if (window.location.pathname != "/login") {
      setTimeout(() => {
        if (attendance && loggedInUser["id"] != 11) {
          // attendanceStatus();
        }
      }, 20000);
      getChatNotification();
    }
    var i = getUser();
    if (i && i["profile_image_url"]) {
      setProfileImage(i["profile_image_url"]);
    }
  }, []);

  const getip = async () => {
    fetch("https://geolocation-db.com/json/")
      .then((res) => res.json())
      .then((data) => setIP(data))
      .catch((e) => console.log(e));
  };

  // const CheckedIn = () => {
  //   let url = "attendanceCheckIn";
  //   const data = {
  //     date: moment().format("YYYY-MM-DD"),
  //     time: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
  //     ip:
  //       ip.IPv4 +
  //       ", " +
  //       ip.city +
  //       ", " +
  //       ip.country_name +
  //       ", " +
  //       ip.country_code,
  //   };
  //   console.log(data);
  //   post_ApiManager(
  //     data,
  //     url,
  //     (res) => {
  //       console.log("CheckedIn", res);
  //       if (res.data.error) swal(" ", res.data.error, "error");
  //       else {
  //         swal("Attendance Marked", "Checked-in successfully!", "success");
  //       }
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // };

  // const attendanceStatus = () => {
  //   let url = `attendanceCheck`;
  //   get_ApiManager(
  //     "",
  //     url,
  //     (res) => {
  //       console.log("attendance-check", res);
  //       setAttendance(false);
  //       if (res.data.data["out"]) {
  //         Swal.fire({
  //           title: "<strong>Attendance</strong>",
  //           icon: "info",
  //           html: "You have not marked your attendance.<b>Please check-in!</b>, ",
  //           showCloseButton: true,
  //           showCancelButton: false,
  //           focusConfirm: false,
  //           confirmButtonText: "Check-In",
  //         }).then((result) => {
  //           /* Read more about isConfirmed, isDenied below */
  //           if (result.isConfirmed) {
  //             getip();
  //             CheckedIn();
  //           }
  //         });
  //       } else if (res.data.data["in"] && !res.data.data["out"]) {
  //         let now = moment().format("DD/MM/YYYY HH:mm:s");
  //         let In = moment(res.data.data["in"]).format("DD/MM/YYYY HH:mm:s");
  //         var total = moment
  //           .utc(
  //             moment(now, "DD/MM/YYYY HH:mm:ss").diff(
  //               moment(In, "DD/MM/YYYY HH:mm:ss")
  //             )
  //           )
  //           .format("H");
  //         if (total > 9) {
  //           Swal.fire({
  //             title: "<strong>Attendance</strong>",
  //             icon: "info",
  //             html:
  //               "You are checked-in since last " +
  //               total +
  //               " Hours <b>Please check-out!</b>, ",
  //             showCloseButton: true,
  //             showCancelButton: false,
  //             focusConfirm: false,
  //             // confirmButtonText: 'Check-Out',
  //           });
  //         }
  //       }
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // };

  const allNotification = async () => {
    try {
      const response = await apiUrl.get("/notifications/unread-count");
      if (response?.status) {
        setNotificationCount(response?.data?.data?.unread_count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!socket) return;

    const onGetNotification = () => {
      allNotification();
    };
    const onEmailSentNotification = () => {
      console.log("sendsendNotification");
      getChatNotification();
    };
    const onGetAlerts = (data) => {
      console.log("socket-data", data.alert_id);
      getSeenAlert(data.alert_id, 2);
    };
    const onGetSeenAlert = (data) => {
      console.log("socket-data", data.alert_id);
      getSeenAlert(data.alert_id, 1);
    };
    const onGetChatNotification = () => {
      console.log("chat-notification (inbox badge refresh)");
      getChatNotification();
    };
    const onDisconnect = (users) => {
      setActiveUsers(users);
    };
    const onGetNotify = () => {
      markAsSeen();
    };

    socket.on("getNotification", onGetNotification);
    socket.on("emailSentNotification", onEmailSentNotification);
    socket.on("getAlerts", onGetAlerts);
    socket.on("getSeenAlert", onGetSeenAlert);
    socket.on("getChatNotification", onGetChatNotification);
    socket.on("disconnect", onDisconnect);
    socket.on("getNotify", onGetNotify);

    return () => {
      socket.off("getNotification", onGetNotification);
      socket.off("emailSentNotification", onEmailSentNotification);
      socket.off("getAlerts", onGetAlerts);
      socket.off("getSeenAlert", onGetSeenAlert);
      socket.off("getChatNotification", onGetChatNotification);
      socket.off("disconnect", onDisconnect);
      socket.off("getNotify", onGetNotify);
    };
  }, [socket]);

  //Call Unseen Notification Api
  const checkToken = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      let url = "checkToken";
      get_ApiManager(
        "",
        url,
        (res) => {
          console.log("checkToken", res);
          if (res.data.auth === false) {
            setIsLoggedIn(false);
            localStorage.clear();
            if (res.data.mfa_enrollment_required && location.pathname !== "/login") {
              history("/login");
              return;
            }
            if (location.pathname !== "/login") {
              swal({
                title: "Session Expired",
                text: "Please log in again!",
                icon: "warning",
                type: "error",
                timer: 1000,
              });
              history("/login");
            }
          } else {
            setIsLoggedIn(true);
          }
        },
        (err) => {
          console.log(err);
        },
      );
    } else {
      setIsLoggedIn(false);
    }
  };
  //Call Unseen Notification Api
  const getSeenStatus = async (status) => {
    let result = await getUnSeen();
    console.log("unseen", result);
    if (result.data["allowed"] == "allowed") {
      setSeenStatus(result.data.data["seenstatus"]);
      if (status === 2) {
        playBellIcon();
      }
    }
  };
  //Call Unseen Notification Api
  const getSeenAlert = async (id, status) => {
    let result = await getUnSeenAlert(id);
    console.log("unseen-alerts", result);
    setSeenAlert(result.data.data["count"]);
    if (result.data.data["allowed"][0] && status === 2) {
      playAlertBellIcon();
      toast("New Alert message is here. Please check your alertbox!");
    }
  };
  const playBellIcon = () => {
    console.log("i m played");
    var sound = new Howl({ src: Bell, volume: 1 });
    sound.play();
  };

  const playAlertBellIcon = () => {
    console.log("alert bell");
    var sound = new Howl({ src: AlertBell, volume: 1 });
    sound.play();
  };

  const markAsSeen = async () => {
    let result = await getMarkAsSeen();
    console.log("MarkAsRead", result);
    getSeenStatus(1);
  };
  const getChatNotification = async () => {
    let result = await getChatNotifications();
    console.log("chat-count", result);
    if (result?.error || result?.data?.data == null) return;
    const payload = result.data.data;
    const raw =
      payload.unreadCount ?? payload.unread_count ?? payload.unread ?? 0;
    const unreadCount = Number(raw);
    setChatNotification({
      ...payload,
      unreadCount: Number.isFinite(unreadCount) ? unreadCount : 0,
    });
  };

  return (
    <div className="App conatiner-fluid">
      <ToastContainer position="top-right" />
      <>
        <Routes>
          <Route
            path="/login"
            element={
              localStorage.getItem("token") ? (
                <Navigate to="/dashboard" />
              ) : (
                <Login socket={socket} user={user} />
              )
            }
          />
          <Route
            path="/"
            element={
              localStorage.getItem("token") ? (
                <Navigate to="/dashboard" />
              ) : (
                <Login socket={socket} user={user} />
              )
            }
          />
          <Route path="/logout" element={<Logout />} />
          <Route path="/preview/invoice" element={<PreviewInvoice />} />
        </Routes>

        {/* Header moved inside content-width — avoids overlapping sidebar */}
        {location.pathname !== "/login" &&
          (localStorage.getItem("token") || location.pathname !== "/") && (
            <div className="row w-100">
              {location.pathname !== "/login" && <Sidebar />}
              <div id="content-width" className="content-width">
                {isLoggedIn &&
                  location.pathname !== "/preview/invoice" &&
                  window.location.pathname !== "/login" && (
                    <nav className="navbar app-top-header w-100">
                      <ul className="navbar-nav app-top-header-nav col-2 w-100">
                        <HeaderQuickOpen
                          icon={
                            <Search size={20} strokeWidth={2} aria-hidden />
                          }
                        />
                        <Inbox
                          inboxSeen={chatNotiication}
                          onRefreshInboxCount={getChatNotification}
                          socket={socket}
                          user={user}
                          icon={
                            <InboxIcon size={20} strokeWidth={2} aria-hidden />
                          }
                        />

                        <NotificationBar
                          count={notificationCount}
                          onRead={() =>
                            setNotificationCount((prev) =>
                              typeof prev === "number" && prev > 0
                                ? prev - 1
                                : 0,
                            )
                          }
                          socket={socket}
                          user={user}
                          icon={
                            <BellIcon size={20} strokeWidth={2} aria-hidden />
                          }
                        />

                        <NavItem
                          icon={
                            profileImage ? (
                              <img
                                className="profile-icon"
                                src={profileImage}
                                alt="Profile"
                              />
                            ) : (
                              <UserCircle size={26} strokeWidth={2} aria-hidden />
                            )
                          }
                        />
                      </ul>
                    </nav>
                  )}
                <Suspense
                  fallback={
                    <div>
                      <Loader />
                    </div>
                  }
                >
                  <Routes>
                    <Route path="/test-form" element={<TestForm />} />
                    <Route
                      path="/:pageName"
                      element={
                        localStorage.getItem("token") ? (
                          <PageNotFound />
                        ) : location.pathname === "/login" ? null : (
                          <Login socket={socket} user={user} />
                        )
                      }
                    />
                    <Route element={<PrivateRoute />}>
                      <Route
                        exact
                        path="task-management"
                        element={<LegacyTaskWorkspaceRedirect />}
                      />
                      <Route
                        exact
                        path="task-management/:id"
                        element={<LegacyTaskWorkspaceRedirect />}
                      />
                      <Route
                        exact
                        path="my-tasks"
                        element={<DailyActivityLogger />}
                      />
                      <Route
                        path="/daily-reporting"
                        element={<DailyReportingDashboard />}
                      />
                      <Route
                        path="/daily-reporting/employee/:id"
                        element={<DailyReportingEmployee />}
                      />
                      <Route
                        exact
                        path="tasks-reporting"
                        element={<LegacyTaskWorkspaceRedirect />}
                      />
                      <Route
                        exact
                        path="website-leads"
                        element={<WebsiteLeads />}
                      />
                      <Route
                        exact
                        path="my-leads"
                        element={<MyWebsiteLeads />}
                      />
                      <Route
                        exact
                        path="walkin-clients"
                        element={<WalkInClients />}
                      />
                      <Route exact path="leads" element={<Leads />} />
                      <Route exact path="campaigns" element={<Compaign />} />

                      <Route exact path="add_leads" element={<AddLeads />} />
                      <Route exact path="my_leads" element={<MyLeads />} />
                      <Route
                        exact
                        path="leads-reporting"
                        element={<LeadsReporting />}
                      />

                      <Route
                        exact
                        path="dashboard"
                        element={<Dashboard socket={socket} user={user} />}
                      />
                      {/* <Route exact path="/tasks/my-tasks" element={<ProcessingTasks />} /> */}
                      <Route
                        exact
                        path="/tasks/my-tasks"
                        element={<ProcessingTasksCards />}
                      />
                      <Route
                        exact
                        path="/employee-attendance/:userid"
                        element={<AttendenceForEmployee />}
                      />
                      <Route
                        exact
                        path="/attendance/:user_id"
                        element={<EmployeeMonthlyAttendance />}
                      />
                      <Route
                        exact
                        path="/view-status-detail/:apptype"
                        element={<ViewStatusDetail />}
                      />
                      <Route
                        exact
                        path="/view-all-followups/:type"
                        element={<ViewAllFollowups />}
                      />
                      <Route
                        exact
                        path="/view-priority/:type"
                        element={<ViewPriority />}
                      />
                      <Route
                        exact
                        path="/view-priority/total"
                        element={<TotalPriority />}
                      />
                      <Route
                        exact
                        path="/view-priority/my"
                        element={<MyPriority />}
                      />
                      <Route
                        exact
                        path="/view-all/:appType"
                        element={<ViewAllStatus />}
                      />
                      <Route
                        exact
                        path="/status-followup/:ftype/:type/:status"
                        element={<StatusFollowup socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/status-invoice-followup/:ftype/:type/:status"
                        element={
                          <StatusFollowup
                            socket={socket}
                            user={user}
                            source="invoice"
                          />
                        }
                      />
                      <Route exact path="/my-profile" element={<Profile />} />
                      <Route
                        exact
                        path="/permissions"
                        element={
                          <PermissionRoute permission="permissions_page">
                            <Permissions />
                          </PermissionRoute>
                        }
                      />
                      <Route
                        exact
                        path="/permissions/user-role"
                        element={<UserRoles />}
                      />
                      {/* Manage Accounts */}
                      <Route
                        path="/accounts/add-account"
                        element={
                          <Navigate
                            to="/accounts/view-accounts?action=add"
                            replace
                          />
                        }
                      />
                      <Route
                        exact
                        path="/accounts/view-accounts"
                        element={<ViewAccounts />}
                      />
                      <Route
                        exact
                        path="/application-fee"
                        element={
                          <FinanceRoute when={canAccessFinanceModule}>
                            <ApplicationFeeRule />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/discount-rule"
                        element={
                          <FinanceRoute when={canAccessFinanceModule}>
                            <DiscountRule />
                          </FinanceRoute>
                        }
                      />
                      {/* Manage Agents */}
                      <Route
                        exact
                        path="/agents/view-agents"
                        element={<ViewAgents />}
                      />
                      <Route
                        exact
                        path="/agents/add-agent"
                        element={<AddAgent />}
                      />
                      <Route
                        exact
                        path="/agents/view-agent/:view_id/:edit"
                        element={<EditAgent />}
                      />
                      <Route
                        exact
                        path="/agents/edit-agent/:view_id/:edit"
                        element={<EditAgent />}
                      />
                      {/* Notifications */}
                      <Route
                        exact
                        path="/notifications/view-all"
                        element={<ShowAllNotification />}
                      />
                      {/* Settings */}
                      <Route
                        exact
                        path="/main-settings"
                        element={
                          <PermissionRoute permission="settings_page">
                            <MainSetttings />
                          </PermissionRoute>
                        }
                      />
                      <Route
                        exact
                        path="/view-activity-detail/:id/:days/:startDate/:endDate"
                        element={<ViewActivityDetail />}
                      />
                      <Route
                        exact
                        path="/view-client-report/:id"
                        element={<ViewClientReport />}
                      />
                      {/* Appointments */}
                      <Route
                        exact
                        path="/appointments/view-appointments"
                        element={<ViewAppointments />}
                      />
                      {/* All Migration Application */}
                      <Route
                        exact
                        path="/applications/all-migration-applications/:statusid/:apptype/:migtype"
                        element={
                          <AllMigrationApps socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/applications/all-education-applications/:statusid/:apptype/:edutype"
                        element={
                          <AllEducationApps socket={socket} user={user} />
                        }
                      />
                      {/* My Applications */}
                      <Route
                        exact
                        path="/applications/main-applications"
                        element={<MainApplications />}
                      />
                      <Route
                        exact
                        path="/applications/my-migrations-applications/:id"
                        element={
                          <MyMigrationsApp socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/applications/my-education-applications/:id"
                        element={<MyEducationApp socket={socket} user={user} />}
                      />
                      {/* Assign Applications */}
                      <Route
                        exact
                        path="/applications/assign-applications"
                        element={<MainApplications />}
                      />
                      <Route
                        exact
                        path="/applications/assign-migrations"
                        element={
                          <AssignMigrationsApp socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/applications/assign-education"
                        element={
                          <AssignEducationApp socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/applications/view-migration-application-detail/:appid"
                        element={
                          <ViewMigrationAppDetail socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/applications/view-education-application-detail/:appid"
                        element={
                          <ViewEducationAppDetail socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/applications/create-migration-application/:clientid/:edit"
                        element={<CreateMigApp socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/applications/create-education-application/:clientid/:edit"
                        element={<CreateEduApp socket={socket} user={user} />}
                      />
                      {/* Clients */}
                      <Route
                        exact
                        path="/clients/view-country-clients/:country"
                        element={<CountryClients />}
                      />
                      <Route
                        exact
                        path="/clients/view-clients"
                        element={<ViewClients socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/external-clients/:from"
                        element={
                          <ExternalClients socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/clients/assign-clients"
                        element={<AssignClients socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/clients/add-client"
                        element={<AddClient socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/clients/my-clients"
                        element={<MyClients socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/clients/user-clients/:clientid"
                        element={<UserClients />}
                      />
                      <Route
                        exact
                        path="/clients/view-leads"
                        element={<ViewLeads />}
                      />
                      <Route
                        exact
                        path="/clients/reports"
                        element={<Reports />}
                      />
                      <Route
                        exact
                        path="/clients/view-client-detail/:id/"
                        element={
                          <ViewClientDetail socket={socket} user={user} />
                        }
                      />
                      <Route
                        exact
                        path="/clients/client-profile/:id/"
                        element={<ViewClientProfile />}
                      />
                      <Route
                        exact
                        path="/clients/client-invoices/:id"
                        element={<ClientInvoices />}
                      />
                      <Route
                        exact
                        path="/clients/create-invoice/:id"
                        element={<ClientCreateInvoice />}
                      />
                      <Route
                        exact
                        path="/clients/edit-invoice/:id/:invoiceId"
                        element={<ClientEditInvoice />}
                      />
                      {/* Counseling */}
                      <Route
                        exact
                        path="/counseling"
                        element={<Counseling />}
                      />
                      {/* Providers */}
                      <Route
                        exact
                        path="/providers/settings"
                        element={<ProviderSettings />}
                      />
                      <Route
                        exact
                        path="/providers/bonus-offer/:providerid"
                        element={<AgentBonus />}
                      />
                      <Route
                        exact
                        path="/providers/view-providers"
                        element={<ViewProviders />}
                      />
                      <Route
                        exact
                        path="/providers/expiring-providers"
                        element={<ExpiringProviders />}
                      />
                      <Route
                        exact
                        path="/providers/provider-insights"
                        element={<ProviderInsights />}
                      />
                      <Route
                        exact
                        path="/providers/add-provider"
                        element={<AddProvider />}
                      />
                      <Route
                        exact
                        path="/providers/edit-provider/:providerid"
                        element={<EditProvider />}
                      />
                      <Route
                        exact
                        path="/providers/provider-details/:providerid/"
                        element={<ProviderDetail socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/providers/add-course/:providerid/:providername/:category/:providercountry"
                        element={<AddCourse />}
                      />
                      <Route
                        exact
                        path="/providers/edit-course/:providerid/:courseid/:providername/:category/:providercountry"
                        element={<EditCourse />}
                      />
                      <Route
                        exact
                        path="/providers/view-intakes"
                        element={<ProviderSettings />}
                      />
                      <Route
                        exact
                        path="/providers/view-levels"
                        element={<ProviderSettings />}
                      />
                      <Route
                        exact
                        path="/providers/provider-categories"
                        element={<ProviderSettings />}
                      />
                      {/* Checklist */}
                      <Route
                        exact
                        path="/checklist"
                        element={<CheckList socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/checklist/create"
                        element={<AddCheckList socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/clients/send-checklist/:clientid/:clientemail/:clientname/:sendername"
                        element={<SendCheckList socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/checklist/main-checklist"
                        element={<MainChecklist />}
                      />
                      <Route
                        exact
                        path="/checklist/view-checklists"
                        element={<ViewChecklists />}
                      />
                      <Route
                        exact
                        path="/checklist/view-pre-checklists"
                        element={<ViewPreChecklists />}
                      />
                      <Route
                        exact
                        path="/checklist/add-pre-checklists"
                        element={<AddPreCheckList />}
                      />
                      <Route
                        exact
                        path="/checklist/view-pre-checklists-details/:pid/:pidname/:cid/:cidname/:migname"
                        element={<ViewPreChecklistDetails />}
                      />
                      <Route
                        exact
                        path="/checklist/add-checklist-category/:edit"
                        element={<AddChecklistCategory />}
                      />
                      <Route
                        exact
                        path="/checklist/checklist-category"
                        element={<CheckListCategories />}
                      />
                      <Route
                        exact
                        path="/checklist/attach"
                        element={<ChecklistToProviders />}
                      />
                      <Route
                        exact
                        path="/checklist/attach/to-provider"
                        element={<AttachCheckListToProviders />}
                      />
                      {/* Finance */}
                      <Route
                        exact
                        path="/finance/professtional-cost"
                        element={
                          <FinanceRoute when={canViewProfessionalCost}>
                            <ViewCost />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/ProfessionalCost"
                        element={
                          <FinanceRoute when={canViewProfessionalCost}>
                            <ProfessionalCost />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/view-commissions"
                        element={
                          <FinanceRoute when={canViewApplicationCommissionReport}>
                            <ViewCommissions />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/health-insurance"
                        element={
                          <FinanceRoute when={canAccessFinanceModule}>
                            <MedicalInsurance />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/gst-settings"
                        element={
                          <FinanceRoute when={canAccessFinanceModule}>
                            <GstSetting />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/invoice-branding"
                        element={
                          <FinanceRoute when={canAccessFinanceModule}>
                            <InvoiceBranding />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/create-invoice"
                        element={
                          <FinanceRoute when={canViewApplicationInvoices}>
                            <FinanceCreateInvoice />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/edit-invoice/:id/:invoiceId"
                        element={
                          <FinanceRoute when={canViewApplicationInvoices}>
                            <FinanceEditInvoice />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/invoices"
                        element={
                          <FinanceRoute when={canAccessFinanceInvoicesHub}>
                            <Invoices />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/invoices/application"
                        element={
                          <FinanceRoute when={canAccessFinanceInvoicesHub}>
                            <Invoices />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/invoices/commission"
                        element={
                          <FinanceRoute when={canAccessFinanceInvoicesHub}>
                            <Invoices />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/finance/commission-installments"
                        element={
                          <FinanceRoute when={canViewCommissionInstallmentsQueue}>
                            <CommissionInstallmentsQueuePage />
                          </FinanceRoute>
                        }
                      />
                      {/* Invoice */}
                      <Route
                        exact
                        path="/invoice/edit-invoice/:invoiceid"
                        element={
                          <FinanceRoute when={canViewProfessionalCost}>
                            <EditInvoice />
                          </FinanceRoute>
                        }
                      />
                      {/* Expo 2022 */}
                      <Route
                        exact
                        path="/expo2022/study-aborad-aug-sep"
                        element={<ExpoAugSep />}
                      />
                      <Route
                        exact
                        path="/events/main"
                        element={<MainEvent />}
                      />
                      <Route
                        exact
                        path="/events/expo-detail/:id"
                        element={<ExpoDetail />}
                      />
                      <Route
                        exact
                        path="/events/expo-consultant-list"
                        element={<ConsultantList />}
                      />
                      <Route
                        exact
                        path="/events/create-event"
                        element={<CreateEvent />}
                      />
                      <Route
                        exact
                        path="/events/followup/:type"
                        element={<ExpoFollowup />}
                      />

                      {/* Reporting */}
                      <Route
                        exact
                        path="/commissions-invoices"
                        element={
                          <FinanceRoute when={canViewCommissionModule}>
                            <Commissions />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/commissions/inquiry-batches"
                        element={
                          <FinanceRoute when={canViewCommissionModule}>
                            <InquiryBatchesPage />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/commissions/inquiry-batches/:batchId"
                        element={
                          <FinanceRoute when={canViewCommissionModule}>
                            <InquiryBatchDetailPage />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/commissions/status-rules"
                        element={
                          <FinanceRoute when={canViewCommissionModule}>
                            <CommissionRulesPage />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/commissions/detail"
                        element={
                          <FinanceRoute when={canViewCommissionModule}>
                            <CommissionDetailRoute />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/commissions/create-invoice/:clientId"
                        element={
                          <FinanceRoute when={canAccessCommissionInvoiceEditor}>
                            <CommissionCreateInvoice />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/commissions/edit-invoice/:clientId/:invoiceId"
                        element={
                          <FinanceRoute when={canAccessCommissionInvoiceEditor}>
                            <CommissionEditInvoice />
                          </FinanceRoute>
                        }
                      />
                      <Route
                        exact
                        path="/client-signup"
                        element={<ClientSignupData />}
                      />
                      <Route
                        exact
                        path="/invoices-reports"
                        element={<InvoiceReports />}
                      />

                      {/* HRManagement */}
                      <Route
                        exact
                        path="/manage-sop-policies"
                        element={<ManageSOP />}
                      />
                      <Route
                        exact
                        path="/sop-policies"
                        element={<SOP_Policies />}
                      />
                      <Route
                        exact
                        path="/sop-policies-categories"
                        element={<SOP_Policies_Categories />}
                      />
                      <Route
                        exact
                        path="/job-descriptions"
                        element={<JobDescriptions />}
                      />
                      <Route
                        exact
                        path="/employee-contracts"
                        element={<EmployeeContracts />}
                      />
                      <Route
                        exact
                        path="/company-forms"
                        element={<CompanyFormsLibrary />}
                      />
                      <Route
                        exact
                        path="/company-forms/manage"
                        element={<CompanyFormsManage />}
                      />
                      <Route
                        exact
                        path="/company-forms/approve"
                        element={<CompanyFormsApprove />}
                      />
                      <Route
                        exact
                        path="/company-forms/categories"
                        element={<CompanyFormsCategories />}
                      />
                      <Route
                        exact
                        path="/manage-policies"
                        element={<Policies />}
                      />
                      <Route
                        exact
                        path="/manage-departments"
                        element={<ManageDepartments />}
                      />
                      <Route
                        exact
                        path="/manage-teams"
                        element={<ManageTeams />}
                      />
                      <Route
                        exact
                        path="/manage-notifications"
                        element={<ManageNotification />}
                      />
                      <Route
                        exact
                        path="/attendance-policies"
                        element={<AttendencePolicies />}
                      />
                      <Route
                        exact
                        path="/leave-policies"
                        element={<LeavePolicies />}
                      />
                      <Route
                        exact
                        path="/attendence"
                        element={<Attendence />}
                      />
                      <Route
                        exact
                        path="/attendence/report"
                        element={<AttendanceReport />}
                      />
                      <Route
                        exact
                        path="/attendence/detail/:userid"
                        element={<AttendenceDetail />}
                      />
                      <Route
                        exact
                        path="/attendence/edit/:editid"
                        element={<EditAttendence />}
                      />
                      {/* Leave */}
                      <Route exact path="/leave" element={<UserLeave />} />
                      <Route
                        exact
                        path="/leave_status/:userid"
                        element={<LeaveRequestStatus />}
                      />
                      <Route
                        exact
                        path="/manage-leaves"
                        element={<HRManageLeaves />}
                      />
                      {/* Alerts */}
                      <Route exact path="/add-alert" element={<AddAlerts />} />
                      <Route
                        exact
                        path="/create-alerts"
                        element={<CreateAlerts socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/alert-detail/:id"
                        element={<AlertDetail />}
                      />
                      {/* Chat */}
                      <Route
                        exact
                        path="/chat"
                        element={
                          <HandleChat
                            activeUsers={activeUsers}
                            socket={socket}
                            user={user}
                          />
                        }
                      />
                      {/* Inbox */}
                      <Route
                        exact
                        path="/handle-inbox"
                        element={
                          <HandleInbox
                            activeUsers={activeUsers}
                            socket={socket}
                            user={user}
                          />
                        }
                      />
                      {/* Branches */}
                      <Route
                        exact
                        path="/manageBranch"
                        element={<ManageBranch socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/branches"
                        element={<Branches socket={socket} user={user} />}
                      />
                      <Route
                        exact
                        path="/external-apps/:type"
                        element={<ExternalApps socket={socket} user={user} />}
                      />
                      {/* Daily Task */}
                      <Route
                        exact
                        path="/task-report"
                        element={<DailyTask />}
                      />
                      <Route
                        exact
                        path="/grant-permissions"
                        element={<Navigate to="/permissions" replace />}
                      />
                      <Route
                        exact
                        path="/all-reports"
                        element={<AllDailyReport />}
                      />
                      <Route
                        exact
                        path="/user-reports/:id"
                        element={<UserReportHistory />}
                      />
                      <Route
                        exact
                        path="/view-report/:id"
                        element={<ViewReport />}
                      />
                      <Route
                        exact
                        path="/view-internal-notes"
                        element={<ViewInternalNotes />}
                      />
                      <Route
                        exact
                        path="/internal-note-detail/:noteid"
                        element={<InternalNoteDetail />}
                      />
                      <Route
                        exact
                        path="/processing-reports"
                        element={<ProcessingReports />}
                      />
                      <Route
                        exact
                        path="/view-processing-report/:id"
                        element={<ViewProcessingReport />}
                      />
                    </Route>
                  </Routes>
                </Suspense>
              </div>
            </div>
          )}
      </>
      {/* Preview Invoice */}
    </div>
  );
}
function PageNotFound() {
  const params = useParams();
  return (
    <p className="w-100 text-center h-100 my-5 bold size-16">
      "{params.pageName}" Ooops! Page not found
    </p>
  );
}

export default App;
